const PLATFORMS_TABLE_READY = "platforms-table-ready"
const SEARCH_TEXT_STATE = "platforms-table-search-text-state"
const ROWS_PER_PAGE_STATE = "platforms-table-rows-per-page-state"
const PAGINATION_STATE = "platforms-table-pagination-state"

const PLATFORMS_ID_FOR_ACTION = "platforms-table-brand-id-for-action"


const ADDEDIT_PLATFORMS_READY = "platforms-table-addedit-platforms-ready"

const initialState = {
    isPlatformsTableReady: true,
    isAddEditPlatformsReady: true,
    platforms: {},

    
    platformsSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case PLATFORMS_TABLE_READY:
            return Object.assign({}, state, { isPlatformsTableReady: action.payload })

        case ADDEDIT_PLATFORMS_READY:
            return Object.assign({}, state, { isAddEditPlatformsReady: action.payload })

            
        
        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchFieldText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case PLATFORMS_ID_FOR_ACTION:
            return Object.assign({}, state, {platformsSelectedId:action.payload})

        default:
        return state
    
    }

}

export function platformsTableReady(data) {
    return {
        type: PLATFORMS_TABLE_READY,
        payload: data
    }
}

export function addEditPlatformsReady(data) {
    return {
        type: ADDEDIT_PLATFORMS_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function platformsIdForAction(platformsId){
    return{
        type:PLATFORMS_ID_FOR_ACTION,
        payload:platformsId
    }
}


// WEBPACK FOOTER //
// ./src/modules/Platforms/redux/platforms.js